"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_SHIMMER_CAROUSEL = exports.BREAKPOINTS = void 0;
var _theme = _interopRequireDefault(require("../Theme/lib/AirasiaClassic/theme"));
const DEFAULT_SHIMMER_CAROUSEL = exports.DEFAULT_SHIMMER_CAROUSEL = {
  CARDS: 4,
  BORDER_RADIUS: _theme.default.borderRadius.normal
};
const BREAKPOINTS = exports.BREAKPOINTS = {
  MOBILE: '599px',
  SMALL_TABLET: '600px',
  MEDIUM_TABLET: '720px',
  LARGE_TABLET: '840px',
  DESKTOP: '1280px'
};